import React, { useEffect, useRef } from 'react';
import { components, MenuListProps, GroupBase } from 'react-select';

export const ScrollBubblingMenuList = <
    Option = unknown,
    IsMulti extends boolean = boolean,
    Group extends GroupBase<Option> = GroupBase<Option>,
>(
    props: MenuListProps<Option, IsMulti, Group>
): JSX.Element => {
    const menuListRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const menuListElement = menuListRef.current;
        if (menuListElement === null) {
            return;
        }

        const handleWheel = (e: WheelEvent): void => {
            const { scrollTop, scrollHeight, clientHeight } = menuListElement;

            const isAtTop = scrollTop === 0;
            const isAtBottom = Math.abs(scrollHeight - clientHeight - scrollTop) < 1;

            const isScrollingUp = e.deltaY < 0;
            const isScrollingDown = e.deltaY > 0;

            const shouldBubble = (isAtTop && isScrollingUp) || (isAtBottom && isScrollingDown);

            if (!shouldBubble) {
                e.stopPropagation();
            }
        };

        menuListElement.addEventListener('wheel', handleWheel, { passive: false, capture: true });

        return (): void => {
            menuListElement.removeEventListener('wheel', handleWheel, { capture: true });
        };
    }, []);

    return (
        <components.MenuList
            {...props}
            innerRef={menuListRef}
        >
            {props.children}
        </components.MenuList>
    );
};
